var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9629 33.352C30.1727 33.352 37.6388 25.8859 37.6388 16.676C37.6388 7.46609 30.1727 0 20.9629 0C11.753 0 4.28687 7.46609 4.28687 16.676C4.28687 25.8859 11.753 33.352 20.9629 33.352Z",
    fill: "#FFD15C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45337 26.4312L1.71558 36.3772L8.41243 36.0217L11.4549 41.9993L16.7628 32.7973C12.9597 31.8134 9.69392 29.5233 7.45337 26.4312Z",
    fill: "#40596B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5053 26.3818C32.2813 29.4822 29.0156 31.7806 25.2207 32.781L30.5451 41.9995L33.5876 36.022L40.2845 36.3775L34.5053 26.3818Z",
    fill: "#40596B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9629 28.7637C27.6386 28.7637 33.0503 23.352 33.0503 16.6763C33.0503 10.0006 27.6386 4.58887 20.9629 4.58887C14.2872 4.58887 8.87549 10.0006 8.87549 16.6763C8.87549 23.352 14.2872 28.7637 20.9629 28.7637Z",
    fill: "#F8B64C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2469 15.3697C29.619 15.0059 29.4123 14.3693 28.8997 14.2949L24.1292 13.6004C23.9225 13.5673 23.7489 13.4433 23.658 13.2531L21.5249 8.92913C21.2934 8.45787 20.6237 8.45787 20.3922 8.92913L18.2674 13.2531C18.1765 13.435 17.9946 13.5673 17.7961 13.6004L13.0257 14.2949C12.5131 14.3693 12.3064 15.0059 12.6784 15.3697L16.1261 18.7346C16.2749 18.8835 16.341 19.0902 16.308 19.2886L15.4977 24.0342C15.4068 24.5468 15.9524 24.9437 16.4154 24.6957L20.6816 22.4551C20.8635 22.3559 21.0867 22.3559 21.2686 22.4551L25.5347 24.6957C25.9977 24.9354 26.5351 24.5468 26.4524 24.0342L25.6339 19.2886C25.6009 19.0819 25.667 18.8752 25.8158 18.7346L29.2469 15.3697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.cae7172b06bff9f256a16e7b7769efb0.svg";
export { ForwardRef as ReactComponent };